import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="sidebar"
// Attach to the sidebar toggle button (#bars-menu)
export default class extends Controller {
  connect() {
    this.restoreState()
    document.addEventListener('turbo:load', this.restoreState.bind(this))
  }

  toggle() {
    const nav = document.querySelector('.dash-left-nav')
    if (!nav) return
    nav.classList.add('slideit')
    nav.classList.toggle('hide')
    if (sessionStorage.getItem('menu') === 'hide') {
      sessionStorage.setItem('menu', 'show')
    } else {
      sessionStorage.setItem('menu', 'hide')
    }
  }

  restoreState() {
    if (sessionStorage.getItem('menu') === 'hide') {
      const nav = document.querySelector('.dash-left-nav')
      if (nav) nav.classList.add('hide')
    }
  }
}
